import MainComponent from "./MainComponent";

export default MainComponent;
